import React, { useState } from 'react';
import TagManager from 'react-gtm-module';
import { ReactComponent as Google } from '../../../img/google.svg';
import { ReactComponent as Facebook } from '../../../img/facebook.svg';
import { ReactComponent as Instagram } from '../../../img/instagram.svg';
import Button from '../Button';
import * as Style from './style';
import color from '../../../config/colors.json';
import api from '../../../services/api';
import { useHistoryPush } from '../../../services/hooks/UseHistoryPush';

export default () => {
	// eslint-disable-next-line no-unused-vars
	const [channel, setChannel] = useState('');

	const sendGtmMetrics = (chosenChannel) => {
		TagManager.dataLayer({
			dataLayer: {
				event: 'trackEvent',
				actionButton: `BTN-CAM-00-${chosenChannel.toUpperCase()}`,
			},
			dataLayerName: 'Campanhas',
		});
    };

	const createBriefing = async (chosenChannel) => {
		await sendGtmMetrics(chosenChannel);
		setChannel(chosenChannel);

		api.post('/api/v2/briefings', {
			answers: [{
				alias: 'channel',
				content: chosenChannel,
			}],
		}, {
			validateStatus: () => true,
		}).then((response) => {
			if (response.status === 201) {
				return useHistoryPush(
					`/campanhas/nova-campanha/${chosenChannel}`,
					{ briefingId: response.data.data.id },
				);
			}
			return false;
		});
	};

	return (
		<Style.Container>
			<Style.Title>Invista em novas campanhas</Style.Title>
			<Style.LinksContainer>
				<Style.CampaignBox>
					<span>A partir de R$800,00/mês</span>
					<div role="img">
						<Google height="86px" width="86px" />
					</div>
					<em>Google</em>
					<div>
						<Button
							type="button"
							padding="10px 0"
							fontSize="12px"
							lineheight="18px"
							backgroundcolor={color.redButtons}
							onClick={() => createBriefing('google')}
						>
							Começar
						</Button>
					</div>
				</Style.CampaignBox>
				<Style.CampaignBox>
					<span>A partir de R$800,00/mês</span>
					<div role="img">
						<Facebook height="86px" width="86px" />
					</div>
					<em>Facebook</em>
					<div>
						<Button
							type="button"
							padding="10px 0"
							fontSize="12px"
							lineheight="18px"
							backgroundcolor={color.redButtons}
							onClick={() => createBriefing('facebook')}
						>
							Começar
						</Button>
					</div>
				</Style.CampaignBox>
				<Style.CampaignBox>
					<span>A partir de R$800,00/mês</span>
					<div role="img">
						<Instagram height="86px" width="86px" />
					</div>
					<em>Instagram</em>
					<div>
						<Button
							type="button"
							padding="10px 0"
							fontSize="12px"
							lineheight="18px"
							backgroundcolor={color.redButtons}
							onClick={() => createBriefing('instagram')}
						>
							Começar
						</Button>
					</div>
				</Style.CampaignBox>
			</Style.LinksContainer>
		</Style.Container>

	);
};
